import { Avatar } from '@mantine/core';

import { Props } from './BankLogo.types';

const BankLogo = ({ domain, name, size }: Props) => {
  const brandfetchClientId = import.meta.env.VITE_BRANDFETCH_CLIENT_ID;
  // /fallback/404/icon forces Brandfetch to respond with a real 404 when it
  // has no logo for the domain, instead of a generic blank image — letting
  // the Avatar's built-in onError fallback (the initial below) kick in.
  const src = domain
    ? `https://cdn.brandfetch.io/${domain}/fallback/404/icon?c=${brandfetchClientId}`
    : undefined;
  const initial = name?.charAt(0).toUpperCase() ?? '?';

  return <Avatar src={src} color="initials" size={size} name={initial} />;
};

export default BankLogo;
